import React, { createContext, useContext, useState, ReactNode } from "react";

interface SelectedStaffContextType {
  selectedStaffId: number | null;
  setSelectedStaffId: (id: number | null) => void;
}

const SelectedStaffContext = createContext<SelectedStaffContextType | undefined>(undefined);

export function SelectedStaffProvider({ children }: { children: ReactNode }) {
  const [selectedStaffId, setSelectedStaffId] = useState<number | null>(null);

  return (
    <SelectedStaffContext.Provider value={{ selectedStaffId, setSelectedStaffId }}>
      {children}
    </SelectedStaffContext.Provider>
  );
}

export function useSelectedStaff() {
  const ctx = useContext(SelectedStaffContext);
  if (!ctx) throw new Error("useSelectedStaff must be used within a SelectedStaffProvider");
  return ctx;
}
